// SEO Text Sections Web Component
class SeoTextSection extends HTMLElement {
  constructor() {
    super();
    this.setupScrollLinks();
  }

  connectedCallback() {
    // Initialize when element is added to DOM
    this.setupScrollLinks();
  }

  setupScrollLinks() {
    // Setup scroll to top links
    const backLinks = this.querySelectorAll('.seo-text-back');
    backLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToSeoTop();
      });
    });

    // Setup read more links
    const readMoreLinks = this.querySelectorAll('.seo-text-read-more');
    readMoreLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToSeoBottom();
      });
    });
  }

  scrollToSeoTop() {
    const topSection = document.getElementById('seo-text-top-section');
    if (topSection) {
      const rect = topSection.getBoundingClientRect();
      const offset = 90; // Header height
      const targetPosition = rect.top + window.pageYOffset - offset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    } else {
      // Fallback: scroll to top of page
      window.scrollTo({ 
        top: 0, 
        behavior: 'smooth' 
      });
    }
  }

  scrollToSeoBottom() {
    const bottomSection = document.getElementById('seo-text-bottom-section');
    if (bottomSection) {
      const rect = bottomSection.getBoundingClientRect();
      const offset = 90; // Header height
      const targetPosition = rect.top + window.pageYOffset - offset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }
}

// Register the custom element (only register once)
if (!customElements.get('seo-text-section')) {
  customElements.define('seo-text-section', SeoTextSection);
}

